import classNames from "classnames";
import Panel from "./components/panel/Panel";
import styles from "./manage-locations.module.css";
import { ReactComponent as SensorEventsIcon } from "../../components/svg/sensor-events.svg";
import { ReactComponent as CameraOrderIcon } from "../../components/svg/camera-order.svg";

import { observer, inject } from "mobx-react";
import SensorEvents from "./components/sensor-events/SensorEvents";
import CameraOrder from "./components/camera-order/CameraOrder";
import Header from "./components/header/Header";
import { useTranslation } from "react-i18next";

function ManageLocationsPage() {
  const { t } = useTranslation(["manage-locations"]);

  const render = () => {
    return (
      <div className={styles["manage-locations"]}>
        <div className={styles["header"]}>
          <Header />
        </div>
        <div className={styles["content"]}>
          <div
            className={classNames(styles["panel-container"], styles["left"])}
          >
            <Panel icon={<CameraOrderIcon />} title={t("CameraTitle")}>
              <CameraOrder />
            </Panel>
          </div>
          <div
            className={classNames(styles["panel-container"], styles["right"])}
          >
            <Panel icon={<SensorEventsIcon />} title={t("SensorEventsTitle")}>
              <SensorEvents />
            </Panel>
          </div>
        </div>
      </div>
    );
  };

  return render();
}

export default inject(
  "mariDataStore",
  "transitionStore"
)(observer(ManageLocationsPage));
